import React, { useContext, useRef, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { useForm } from "react-hook-form";
import "./Otp.css";
import { AuthContext } from "../../../Context/AuthContext";

const Otp = () => {
  const { login } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const { mobile, user } = location.state || {};

  const { register, handleSubmit, setValue, formState: { errors }, setFocus } = useForm();
  
  const referenceNumber = location.state?.user?.referenceNumber;
  const verificationCode = location.state?.user?.verificationCode;

  const otpInputs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null)
  ];

  const [resendTimer, setResendTimer] = useState(60); // Timer for 1 minute
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    for (let i = 0; i < otpInputs.length; i++) {
      if (!otpInputs[i].current.value) {
        otpInputs[i].current.focus();
        break;
      }
    }
  }, []);

  useEffect(() => {
    let timer;
    if (isResendDisabled && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [resendTimer, isResendDisabled]);

  const resendOtp = async () => {
    try {
      const response = await axios.post(`${Api_Url}api/Account/login-with-mobile`, {"mobile":mobile});
      if (response.data.succeeded) {
        alert("OTP resent successfully!");
        setResendTimer(60); // Reset the timer
        setIsResendDisabled(true);
      } else {
        alert("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const { otp1, otp2, otp3, otp4, otp5, otp6 } = data;
    const otp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;

    try {
      const response = await axios.post(`${Api_Url}api/Account/login-otp-verify`, { otp, mobile, verificationCode, referenceNumber });
      if (response.data.succeeded) {
        login(response.data.data);
        navigate('/roles');
      } else {
        alert("OTP verification failed");
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false); // Stop loader
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    setValue(e.target.name, value);

    if (/^[0-9]?$/.test(value)) {
      if (value && index < otpInputs.length - 1) {
        otpInputs[index + 1].current.focus();
      }
      if (!value && index > 0) {
        otpInputs[index - 1].current.focus();
      }
    }
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <Link to="/admin-dashboard">
                <img src={Applogo} alt="Roha housing" />
              </Link>
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">OTP</h3>
                <p className="account-subtitle">Verify your account</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="otp-wrap">
                    {["otp1", "otp2", "otp3", "otp4", "otp5", "otp6"].map((field, index) => (
                      <input
                        key={field}
                        type="text"
                        placeholder="0"
                        maxLength={1}
                        className={`otp-input ${errors[field] ? 'is-invalid' : ''}`}
                        {...register(field, { required: "This field is required" })}
                        ref={otpInputs[index]}
                        onChange={(e) => handleOtpChange(e, index)}
                      />
                    ))}
                  </div>
                  <div className="input-block mb-4 text-center">
                    <button type="submit" className="btn btn-primary account-btn" disabled={loading}>
                      Enter
                    </button>
                  </div>
                </form>
                {loading && (
                      <div className="text-center mt-3">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    )}
                <div className="account-footer">
                  <p>
                    Not yet received?{" "}
                    <button
                      onClick={resendOtp}
                      disabled={isResendDisabled}
                      className="resend-otp-btn"
                    >
                      Resend OTP {isResendDisabled && `in ${resendTimer}s`}
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;


// import React, { useContext, useRef, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { Applogo } from "../../../Routes/ImagePath";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { useForm } from "react-hook-form";
// import "./Otp.css"; 
// import { AuthContext } from "../../../Context/AuthContext";

// const Otp = () => {
//   const { login } = useContext(AuthContext);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { mobile, user } = location.state || {};

//   const { register, handleSubmit, setValue, formState: { errors }, setFocus } = useForm();
  
//   const referenceNumber = location.state?.user?.referenceNumber;
//   const verificationCode = location.state?.user?.verificationCode;

//   console.log(referenceNumber, verificationCode);

//   const otpInputs = [
//     useRef(null),
//     useRef(null),
//     useRef(null),
//     useRef(null),
//     useRef(null),
//     useRef(null)
//   ];

//   // Effect to focus the first empty OTP input when the page is loaded
//   useEffect(() => {
//     for (let i = 0; i < otpInputs.length; i++) {
//       if (!otpInputs[i].current.value) {
//         otpInputs[i].current.focus(); // Focus the first empty input
//         break;
//       }
//     }
//   }, []);  // Empty dependency array ensures it runs once when the component is mounted

//   const onSubmit = async (data) => {
//     const { otp1, otp2, otp3, otp4, otp5, otp6 } = data;
//     const otp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;

//     try {
//       const response = await axios.post(`${Api_Url}api/Account/login-otp-verify`, { otp, mobile, verificationCode, referenceNumber });
//       console.log("res", response);

//       if (response.data.succeeded === true) {
//         login(response.data.data);
//         navigate('/roles');
//       } else {
//         alert("OTP verification failed");
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleOtpChange = (e, index) => {
//     const value = e.target.value;
//     setValue(e.target.name, value);

//     // Focus logic for when a user types or deletes
//     if (/^[0-9]?$/.test(value)) {
//       // If the field is filled, move focus to the next field
//       if (value && index < otpInputs.length - 1) {
//         otpInputs[index + 1].current.focus();
//       }
//       // If the field is empty (backspace), move focus to the previous field
//       if (!value && index > 0) {
//         otpInputs[index - 1].current.focus();
//       }
//     }
//   };

//   return (
//     <div className="account-page">
//       <div className="main-wrapper">
//         <div className="account-content">
//           <div className="container">
//             <div className="account-logo">
//               <Link to="/admin-dashboard">
//                 <img src={Applogo} alt="Roha housing" />
//               </Link>
//             </div>
//             <div className="account-box">
//               <div className="account-wrapper">
//                 <h3 className="account-title">OTP</h3>
//                 <p className="account-subtitle">Verify your account</p>
//                 <form onSubmit={handleSubmit(onSubmit)}>
//                   <div className="otp-wrap">
//                     {["otp1", "otp2", "otp3", "otp4", "otp5", "otp6"].map((field, index) => (
//                       <input
//                         key={field}
//                         type="text"
//                         placeholder="0"
//                         maxLength={1}
//                         className={`otp-input ${errors[field] ? 'is-invalid' : ''}`}
//                         {...register(field, { required: "This field is required" })}
//                         ref={otpInputs[index]} // Assign the ref
//                         onChange={(e) => handleOtpChange(e, index)} // Handle both typing and deleting
//                       />
//                     ))}
//                   </div>
//                   <div className="input-block mb-4 text-center">
//                     <button type="submit" className="btn btn-primary account-btn">
//                       Enter
//                     </button>
//                   </div>
//                   <div className="account-footer">
//                     {/* <p>
//                       Not yet received? <Link to="#" onClick={resendOtp}>Resend OTP</Link>
//                     </p> */}
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Otp;










// import React, { useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { Applogo } from "../../../Routes/ImagePath";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { useForm } from "react-hook-form";
// import './Otp.css'

// const Otp = () => {

  
//   const location = useLocation();
//   console.log("object",location)
//   const navigate = useNavigate();
//   const { mobile, user } = location.state || {}; 
  

//   const { register, handleSubmit, setValue, formState: { errors } } = useForm();

//   const onSubmit = async (data) => {
//     const { otp1, otp2, otp3, otp4, otp5,otp6 } = data;
//     const otp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;

//     try {
//       const response = await axios.post(`${Api_Url}api/verify-otp`, { otp, mobile });
//       console.log("res", response);

//       if (response.status === 200) {
//         navigate("/reset");
//       } else {
//         alert("OTP verification failed");
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleOtpChange = (setOtp) => (e) => {
//     const value = e.target.value;
//     if (/^[0-9]?$/.test(value)) {
//       setOtp(value);
//       setValue(e.target.name, value);
//     }
//   };

//   return (
//     <div className="account-page">
//       <div className="main-wrapper">
//         <div className="account-content">
//           <div className="container">
//             <div className="account-logo">
//               <Link to="/admin-dashboard">
//                 <img src={Applogo} alt="Roha housing" />
//               </Link>
//             </div>
//             <div className="account-box">
//               <div className="account-wrapper">
//                 <h3 className="account-title">OTP</h3>
//                 <p className="account-subtitle">Verification your account</p>
//                 <form onSubmit={handleSubmit(onSubmit)}>
//                   <div className="otp-wrap">
//                     <input
//                       type="text"
//                       placeholder="0"
//                       maxLength={1}
//                       className={` otp-input ${errors.otp1 ? 'is-invalid' : ''}`}
//                       {...register("otp1", { required: "This field is required" })}
//                       onChange={handleOtpChange(setValue)}
//                     />
//                     {/* {errors.otp1 && <span className="text-danger">{errors.otp1.message}</span>} */}
//                     <input
//                       type="text"
//                       placeholder="0"
//                       maxLength={1}
//                       className={`otp-input ${errors.otp2 ? 'is-invalid' : ''}`}
//                       {...register("otp2", { required: "This field is required" })}
//                       onChange={handleOtpChange(setValue)}
//                     />
//                     {/* {errors.otp2 && <span className="text-danger">{errors.otp2.message}</span>} */}
//                     <input
//                       type="text"
//                       placeholder="0"
//                       maxLength={1}
//                       className={`otp-input ${errors.otp3 ? 'is-invalid' : ''}`}
//                       {...register("otp3", { required: "This field is required" })}
//                       onChange={handleOtpChange(setValue)}
//                     />
//                     {/* {errors.otp3 && <span className="text-danger">{errors.otp3.message}</span>} */}
//                     <input
//                       type="text"
//                       placeholder="0"
//                       maxLength={1}
//                       className={`otp-input ${errors.otp4 ? 'is-invalid' : ''}`}
//                       {...register("otp4", { required: "This field is required" })}
//                       onChange={handleOtpChange(setValue)}
//                     />
//                     <input
//                       type="text"
//                       placeholder="0"
//                       maxLength={1}
//                       className={` otp-input ${errors.otp5 ? 'is-invalid' : ''}`}
//                       {...register("otp5", { required: "This field is required" })}
//                       onChange={handleOtpChange(setValue)}
//                     />
//                     <input
//                       type="text"
//                       placeholder="0"
//                       maxLength={1}
//                       className={` otp-input ${errors.otp6 ? 'is-invalid' : ''}`}
//                       {...register("otp6", { required: "This field is required" })}
//                       onChange={handleOtpChange(setValue)}
//                     />
//                     {/* {errors.otp4 && <span className="text-danger">{errors.otp4.message}</span>} */}
//                   </div>
//                   <div className="input-block mb-4 text-center">
//                     <button type="submit" className="btn btn-primary account-btn">
//                       Enter
//                     </button>
//                   </div>
//                   <div className="account-footer">
//                     {/* <p>
//                       Not yet received? <Link to="#" onClick={resendOtp}>Resend OTP</Link>
//                     </p> */}
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Otp;









// // import React, { useState } from "react";
// // import { Link, useNavigate } from "react-router-dom";
// // import { Applogo } from "../../../Routes/ImagePath";
// // import { Api_Url } from "../../../config/config";
// // import axios from "axios";
// // // import { useLocation } from "react-router-dom";

// // const Otp = () => {
// //   // const location = useLocation();

// //   // const userData = location.state;
// //   // console.log("userData", userData);


// //   const navigate = useNavigate();
// //   const [otp1, setOtp1] = useState("");
// //   const [otp2, setOtp2] = useState("");
// //   const [otp3, setOtp3] = useState("");
// //   const [otp4, setOtp4] = useState("");

// //   const handleOtpChange = (setOtp) => (e) => {
// //     const value = e.target.value;
// //     if (/^[0-9]?$/.test(value)) { // Ensure only digits are allowed and max length is 1
// //       setOtp(value);
// //     }
// //   };

// //   const VerifyOtp = async () => {
// //     try {
// //       const otp = otp1 + otp2 + otp3 + otp4;
// //       const data = { otp };
// //       const response = await axios.post(`${Api_Url}verify-otp`, data); // Adjust URL and method as needed
// //       console.log("res", response);

// //       if (response.status === 200) {
// //         navigate("/reset");
// //       } else {
// //         alert("otp error")
// //       }
// //     } catch (error) {
// //       console.error(error);
// //     }
// //   };

// //   return (
// //     <>
// //       <div className="account-page">
// //         {/* Main Wrapper */}
// //         <div className="main-wrapper">
// //           <div className="account-content">
// //             <div className="container">
// //               {/* Account Logo */}
// //               <div className="account-logo">
// //                 <Link to="/admin-dashboard">
// //                   <img src={Applogo} alt="Roha housing" />
// //                 </Link>
// //               </div>
// //               {/* /Account Logo */}
// //               <div className="account-box">
// //                 <div className="account-wrapper">
// //                   <h3 className="account-title">OTP</h3>
// //                   <p className="account-subtitle">Verification your account</p>
// //                   {/* Account Form */}
// //                   <form onSubmit={(e) => { e.preventDefault(); VerifyOtp(); }}>
// //                     <div className="otp-wrap">
// //                       <input
// //                         type="text"
// //                         placeholder={0}
// //                         maxLength={1}
// //                         className="otp-input"
// //                         value={otp1}
// //                         onChange={handleOtpChange(setOtp1)}
// //                       />
// //                       <input
// //                         type="text"
// //                         placeholder={0}
// //                         maxLength={1}
// //                         className="otp-input"
// //                         value={otp2}
// //                         onChange={handleOtpChange(setOtp2)}
// //                       />
// //                       <input
// //                         type="text"
// //                         placeholder={0}
// //                         maxLength={1}
// //                         className="otp-input"
// //                         value={otp3}
// //                         onChange={handleOtpChange(setOtp3)}
// //                       />
// //                       <input
// //                         type="text"
// //                         placeholder={0}
// //                         maxLength={1}
// //                         className="otp-input"
// //                         value={otp4}
// //                         onChange={handleOtpChange(setOtp4)}
// //                       />
// //                     </div>
// //                     <div className="input-block mb-4 text-center">
// //                       <button
// //                         type="submit"
// //                         className="btn btn-primary account-btn"
// //                       >
// //                         Enter
// //                       </button>
// //                     </div>
// //                     <div className="account-footer">
// //                       {/* <p>
// //                         Not yet received? <Link to="#" onClick={resendOtp}>Resend OTP</Link>
// //                       </p> */}
// //                     </div>
// //                   </form>
// //                   {/* /Account Form */}
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //         {/* /Main Wrapper */}
// //       </div>
// //     </>
// //   );
// // };

// // export default Otp;

















// // // import React from "react";
// // // import { Link } from "react-router-dom";
// // // import { Applogo } from "../../../Routes/ImagePath";
// // // import { Api_Url } from "../../../config/config";
// // // import axios from "axios";

// // // const Otp = () => {

  
// // //   const [otp, setOtp] = React.useState("");

// // //   const VerifyOtp =  ()=>{
// // //     try {
// // //       const data = {otp};
// // //       const response = axios.get(`${Api_Url}`,data)
// // //       console.log("res",response)
// // //     } catch (error) {
// // //       return error
// // //     }
// // //   }

  



// // //   return (
// // //     <>
// // //       <div className="account-page">
// // //         {/* Main Wrapper */}
// // //         <div className="main-wrapper">
// // //           <div className="account-content">
// // //             <div className="container">
// // //               {/* Account Logo */}
// // //               <div className="account-logo">
// // //                 <Link to="/admin-dashboard">
// // //                   <img src={Applogo} alt="Roha housing" />
// // //                 </Link>
// // //               </div>
// // //               {/* /Account Logo */}
// // //               <div className="account-box">
// // //                 <div className="account-wrapper">
// // //                   <h3 className="account-title">OTP</h3>
// // //                   <p className="account-subtitle">Verification your account</p>
// // //                   {/* Account Form */}
// // //                   <form action="admin-dashboard">
// // //                     <div className="otp-wrap">
// // //                       <input
// // //                         type="text"
// // //                         placeholder={0}
// // //                         maxLength={1}
// // //                         className="otp-input"
// // //                       />
// // //                       <input
// // //                         type="text"
// // //                         placeholder={0}
// // //                         maxLength={1}
// // //                         className="otp-input"
// // //                       />
// // //                       <input
// // //                         type="text"
// // //                         placeholder={0}
// // //                         maxLength={1}
// // //                         className="otp-input"
// // //                       />
// // //                       <input
// // //                         type="text"
// // //                         placeholder={0}
// // //                         maxLength={1}
// // //                         className="otp-input"
// // //                       />
// // //                     </div>
// // //                     <div className="input-block mb-4 text-center">
// // //                       <Link
// // //                         to="/admin-dashboard"
// // //                         className="btn btn-primary account-btn"
// // //                         type="button"
// // //                         onClick={VerifyOtp}
// // //                       >
// // //                         Enter
// // //                       </Link>
// // //                     </div>
// // //                     <div className="account-footer">
// // //                       {/* <p>
// // //                         Not yet received? <Link to="#" onClick={resendOtp}>Resend OTP</Link>
// // //                       </p> */}
// // //                     </div>
// // //                   </form>
// // //                   {/* /Account Form */}
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //         {/* /Main Wrapper */}
// // //       </div>
// // //     </>
// // //   );
// // // };

// // // export default Otp;
